<template>
    <div :class="customClass">
        <div
            class="footer viewport"
            v-show="footerVisible"
        >
            <div class="container">
                <div class="flex full-width">
                    <div class="column footer-left">
                        <div class="row q-mb-xl footer-logo-panel"><img alt="Elena" src=@/assets/elenaLogoDark.svg loading="lazy" class="footer-logo" /></div>
                        <p class="text-h6 text-white q-mt-xl">Chcete dostávať novinky emailom? Prihláste sa na odber:</p>
                        <q-form
                            ref="form"
                            @submit="submitForm"
                            class="full-width"
                        >
                            <div class="searchPanel row full-width">
                                <q-input
                                    label="Emailová adresa"
                                    v-model.trim="email"
                                    outlined
                                    bg-color="white"
                                    class="searchInput col-grow"
                                    ref="mailInputRef"
                                    lazy-rules
                                    type="email"
                                    :rules="$e.form.rules({ required: { required: true }, email: { multiple: false } })"
                                    hide-bottom-space
                                />
                                <div class="buttonPanel">
                                    <q-btn
                                        :flat="!$q.screen.lt.md"
                                        :outline="$q.screen.lt.md"
                                        :label="$q.screen.lt.md ? 'Prihlásiť sa' : ''"
                                        icon="send"
                                        color="white"
                                        class="searchBtn q-ml-sm"
                                        type="submit"
                                    />
                                </div>
                            </div>
                        </q-form>
                    </div>
                    <div class="column footer-right">
                        <h3 class="q-mb-xl q-mt-none text-white">Kontakt</h3>
                        <div class="contact-block">
                            <div class="contact-item">
                                <div class="flex items-start item">
                                    <svg
                                        viewBox="0 0 1024 1024"
                                        class="contact-icon"
                                    >
                                        <path
                                            d="M753.365 226.304c-133.291-131.115-349.397-131.115-482.688 0-133.291 131.157-133.291 343.765 0 474.88l241.323 237.44 241.365-237.44c133.291-131.115 133.291-343.723 0-474.88zM512 575.957c-28.501 0-55.253-11.093-75.435-31.232-41.6-41.6-41.6-109.269 0-150.869 20.139-20.139 46.933-31.232 75.435-31.232s55.296 11.093 75.435 31.232c41.6 41.6 41.6 109.312 0 150.869-20.139 20.139-46.933 31.232-75.435 31.232z"
                                        ></path>
                                    </svg>
                                    <div class="contact-info">
                                        ELENA, a.s
                                        <br />
                                        Barčianska 68
                                        <br />
                                        Košice - mestská časť Barca, 040&nbsp;17
                                    </div>
                                </div>
                            </div>
                            <div class="contact-item">
                                <div class="flex items-center item">
                                    <img class="contact-icon" alt="ičo" src=@/assets/ico.svg />
                                    <div class="contact-info">53881796</div>
                                </div>
                            </div>
                            <div class="contact-item">
                                <div class="flex items-center item">
                                    <img class="contact-icon" alt="dič" src=@/assets/dic.svg />
                                    <div class="contact-info">2121520632</div>
                                </div>
                            </div>
                            <div class="contact-item">
                                <div class="flex items-center item">
                                    <a :href="`mailto:${contactInfo?.kontaktnyMail}?subject=Správa zo stránky ElenaPortal.sk`">
                                        <div class="flex items-center">
                                            <svg
                                                viewBox="0 0 1024 1024"
                                                class="contact-icon"
                                            >
                                                <path
                                                    d="M854 342v-86l-342 214-342-214v86l342 212zM854 170q34 0 59 26t25 60v512q0 34-25 60t-59 26h-684q-34 0-59-26t-25-60v-512q0-34 25-60t59-26h684z"
                                                ></path>
                                            </svg>
                                            <div class="contact-info">{{ contactInfo?.kontaktnyMail }}</div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div class="contact-item q-mt-lg socialPanel">
                                <div class="flex items-center item">
                                    <a
                                        :href="socialFb"
                                        target="_blank"
                                        class="noHover"
                                    >
                                        <q-btn
                                            outline
                                            icon="svguse:images/brands.svg#fb"
                                            color="white"
                                            class="socialBtn"
                                        />
                                    </a>
                                    <a
                                        :href="socialIn"
                                        target="_blank"
                                        class="noHover q-ml-md"
                                    >
                                        <q-btn
                                            outline
                                            icon="svguse:images/brands.svg#in"
                                            color="white"
                                            class="socialBtn"
                                        />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="flex text-center q-py-md q-px-md justify-center"
            style="font-size: 14px"
        >
            © 2023 www.elenaportal.sk
            <q-separator
                vertical
                class="q-mx-sm"
            />
            Všetky práva vyhradené
            <q-separator
                vertical
                class="q-mx-sm"
            />
            Vlastník ELENA, a.s.
            <q-separator
                vertical
                class="q-mx-sm"
            />
            <span class="footer-copyright">
                Vytvoril
                <a
                    href="http://www.enforb.eu"
                    target="_blank"
                    rel="noopener noreferrer"
                    >Enforb s.r.o.</a
                >
            </span>
            <q-separator
                vertical
                class="q-mx-sm"
            />
            <span class="footer-copyright">
                <a
                    @click="$e.showCookieNotify()"
                    style="cursor: pointer"
                    >O cookies</a
                >
            </span>
        </div>
    </div>
</template>

<script>
import $e from '@enfis/quasar';
import { mapState } from 'vuex';

export default {
    name: 'VpFooter',
    props: ['customClass', 'onlyCopyright'],
    data() {
        return {
            email: '',
            footerVisible: true,
            socialFb: process.env.VUE_APP_CONTACT_SOCIAL_FB,
            socialIn: process.env.VUE_APP_CONTACT_SOCIAL_IN,
        };
    },
    methods: {
        submitForm() {
            const htmlMsg =
                '<style type="text/css">@media screen and (max-width: 767px) {.tg {width: auto !important;}.tg col {width: auto !important;}.tg-wrap {overflow-x: auto;-webkit-overflow-scrolling: touch;margin: auto 0px;}}</style><div class="tg-wrap"><table style="border-collapse:collapse;border-spacing:0;margin:0px auto;table-layout: fixed; width: 849px" class="tg"><colgroup><col style="width: 849px"></colgroup><tbody><tr><td style="background-color:#efefef;border-color:#ffffff;border-style:solid;border-width:0px;font-family:Arial, sans-serif;font-size:xx-large;font-weight:bold;overflow:hidden;padding:10px 20px;text-align:center;vertical-align:top;word-break:normal">Prihlásenie sa na odber noviniek zo stránky ElenaPortal.sk</td></tr><tr><td style="background-color:#ffffff;border-color:#ffffff;border-style:solid;border-width:0px;font-family:Arial, Helvetica, sans-serif !important;font-size:large;overflow:hidden;padding:10px 20px;text-align:center;vertical-align:top;word-break:normal"><span style="font-weight:bold">Emailová adresa:</span> ' +
                this.email +
                '</td></tr><tr><td style="border-color:#ffffff;border-style:solid;border-width:0px;font-family:Arial, sans-serif;font-size:small;overflow:hidden;padding:10px 20px;text-align:center;vertical-align:top;word-break:normal"></td></tr><tr><td style="border-style:solid;border-width:0px;font-family:Arial, sans-serif;font-size:14px;overflow:hidden;padding:10px 20px;text-align:left;vertical-align:top;word-break:normal"></td></tr><tr><td style="border-style:solid;border-width:0px;font-family:Arial, sans-serif;font-size:14px;overflow:hidden;padding:10px 20px;text-align:left;vertical-align:top;word-break:normal"></td></tr><tr><td style="background-color:#ffffff;border-color:#ffffff;border-style:solid;border-width:0px;font-family:Arial, Helvetica, sans-serif !important;font-size:x-small;overflow:hidden;padding:10px 20px;text-align:center;vertical-align:top;word-break:normal">Toto je automaticky generovaný email. Prosím neodpovedajte naň.</td></tr></tbody></table></div>';

            let methodName = 'sendMailDirect';
            let methodParameters = {
                'mail-subject': 'Prihlásenie sa na odber noviniek zo stránky ElenaPortal.sk',
                'mail-message': htmlMsg,
                'mail-reply_to_address': this.email,
            };

            $e.io.callMethod(methodName, methodParameters, {
                success: () => {
                    $e.notify.success('Boli ste úspešne zaradený do zoznamu odberu noviniek.');
                    this.resetForm();
                },
                error: () => {
                    $e.notify.error('Niekde nastala chyba. Skúste to prosím neskôr.');
                },
                afterError: () => {},
            });
        },
        resetForm() {
            this.name = '';
            this.email = '';
            this.msg = '';
            this.$refs.form.resetValidation();
        },
    },
    mounted() {
        this.footerVisible = this.onlyCopyright == null;
    },
    computed: {
        ...mapState(['contactInfo']),
    },
};
</script>

<style lang="scss" scoped>
.container {
    max-width: $breakpoint-md-max;

    @media (max-width: $breakpoint-sm-max) {
        padding: 64px 16px;
    }
}

.footer {
    background: linear-gradient(333deg, rgba(0, 46, 129, 1) 0%, rgba(13, 69, 172, 1) 33%, rgba(34, 70, 136, 1) 67%, rgba(3, 37, 98, 1) 100%);
}

.q-btn {
    min-height: 56px;
}
.footer-left {
    padding-right: 64px;
    width: 60%;

    a {
        display: flex;
        width: 100%;
    }
    .footer-logo {
        text-decoration: none;
        width: 100%;
        max-width: 565px;
    }

    .searchInput {
        max-width: 520px;
        :deep() .q-btn {
            padding: 0 !important;
        }
    }

    .buttonPanel {
        width: auto;
        margin-top: 0;
    }
    @media (max-width: $breakpoint-sm-max) {
        width: 100%;
        padding-right: 0px;
        align-items: center;

        a {
            display: block;
        }
        .footer-logo-panel {
            justify-content: center;
            .footer-logo {
                width: 80%;
            }
        }

        p {
            text-align: center;
        }

        .searchPanel {
            align-items: center;
            flex-direction: column;

            .searchInput {
                width: 100%;
            }

            .buttonPanel {
                width: 100%;
                margin-top: 0;
                text-align: center;
                .searchBtn {
                    width: 100%;
                    max-width: 300px;
                    margin-left: 0;
                    margin-top: 16px;
                }
            }
        }
    }

    @media (max-width: $breakpoint-xs-max) {
        > div {
            width: 100%;
            text-align: center;
        }
        .footer-logo {
            width: 100%;
        }
    }
}

.footer-right {
    width: 40%;
    .contact-block {
        border-left: 1px solid white;
        .contact-item {
            padding-left: 16px;
            width: 100%;
            margin-bottom: 8px;

            .item {
                min-height: 56px;
                padding: 0 16px;
                font-size: 1em !important;
            }

            &:last-child {
                margin-bottom: 0px;
            }
        }
    }
    .contact-icon {
        fill: #fff;
        height: 32px;
        width: 32px;
        display: flex;
        flex: 0 1 32px;
    }
    .contact-info {
        color: #fff;
        padding-left: 16px;
        display: flex;
        flex: 1 0;
    }

    a {
        &:before {
            background-color: #a0c0ff;
        }
        .contact-icon {
            fill: #a0c0ff;
            transition: fill 0.1s ease-in-out;
        }

        .contact-info {
            color: #a0c0ff;
            transition: color 0.1s ease-in-out;
        }

        &:hover {
            &:before {
                background-color: white;
            }
            .contact-info {
                color: white;
            }
            .contact-icon {
                fill: white;
            }
        }

        .socialBtn {
            width: 100%;
            max-width: 200px;
            margin-left: 0;
        }
    }

    @media (max-width: $breakpoint-sm-max) {
        width: 100%;
        margin-top: 100px;

        h3 {
            text-align: center;
        }

        .contact-block {
            border: none;
            display: flex;
            flex-direction: column;
            align-items: center;

            .contact-item {
                padding: 0;
                display: flex;
                justify-content: center;
                max-width: 320px;

                .item {
                    padding: 0;
                    width: 100%;

                    .contact-icon {
                        width: 32px;
                    }
                }

                &.socialPanel {
                    .item {
                        justify-content: center;
                    }
                }
            }
        }
    }
}

// .footer-copyright {
//     a {
//         text-decoration: none;
//         color: $primary;

//         &:hover {
//             text-decoration: underline;
//         }
//     }
// }

:deep() .q-field {
    &.q-field--error .q-field__bottom {
        color: rgb(255, 100, 100);
    }
}
</style>
